// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"1aa655e8","73":"918eec7c","585":"da433cde","626":"9197dcbf","656":"325d21fc","810":"6923659e","927":"9389dd83"}[chunkId] + ".chunk.js";
};